
import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';

export const CustomChip = props => {
    const { customChipKey, value, className , trimming} = props;
    return (
        <div key={customChipKey} className={className}> {!trimming && value && value.length > 14 ?
            <Tooltip key={`${value}-${Math.random()}`} title={value}>
                <Typography variant={'caption'}>{value.slice(0, 13)}...</Typography>
            </Tooltip>
            : <Typography variant={'caption'}>{value ?value  : 'n/a'}</Typography>}</div>
    );
};